import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["tabindex", "id", "aria-expanded", "aria-owns", "aria-activedescendant", "aria-disabled", "aria-labelledby"]
const _hoisted_2 = {
  class: "customSelectWrapper",
  role: "presentation"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_6 = ["aria-labelledby"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["aria-selected", "id", "onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_10 = {
  key: 1,
  class: "dropdown-divider"
}
const _hoisted_11 = ["aria-selected", "id", "onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_13 = {
  class: "d-none",
  type: "text",
  ref: "validationInput"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      role: "combobox",
      class: ["form-select customSelectSelect", { 'is-invalid': _ctx.wasValidated && _ctx.validationError !== _ctx.ValidationError.NONE }],
      tabindex: _ctx.disabled ? null : '0',
      onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.keydown && _ctx.keydown(...args))),
      id: _ctx.selectId,
      "aria-expanded": _ctx.expanded ? 'true' : 'false',
      "aria-owns": _ctx.$id('dropdown'),
      "aria-activedescendant": _ctx.$id('item' + _ctx.selectedIndex),
      "aria-autocomplete": "none",
      ref: "select",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle())),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hide()))
    }, _ctx.$attrs, {
      "aria-disabled": _ctx.disabled ? 'true' : 'false',
      "aria-labelledby": _ctx.labelId
    }), [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _renderSlot(_ctx.$slots, "option", {
          option: _ctx.flattenedOptions[_ctx.selectedIndex],
          main: true
        }, () => [
          _createTextVNode(_toDisplayString(_ctx.selectedIndex != null ? _ctx.trueOptionLabel(_ctx.flattenedOptions[_ctx.selectedIndex]) : ''), 1)
        ])
      ])
    ], 16, _hoisted_1),
    _createElementVNode("div", {
      id: _ctx.$id('dropdown'),
      class: "dropdown-menu start-0 customSelectDropdown",
      ref: "dropdown",
      role: "listbox",
      tabindex: "-1",
      onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderOptions, (item, optionIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: optionIndex }, [
            (item === _ctx.selectDivider)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
              : _createCommentVNode("", true),
            (item[0] === 'group')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  role: "group",
                  "aria-labelledby": _ctx.$id('header' + optionIndex)
                }, [
                  _createElementVNode("h6", {
                    class: "dropdown-header",
                    id: _ctx.$id('header' + optionIndex),
                    role: "presentation"
                  }, _toDisplayString(item[1]), 9, _hoisted_7),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[2], (child, optionIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: optionIndex }, [
                      (child[0] === 'option')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            tabindex: "-1",
                            class: _normalizeClass(["dropdown-item", {
                  'active': _ctx.selectedIndex === child[2],
              }]),
                            role: "option",
                            "aria-selected": _ctx.selectedIndex === child[2] ? 'true' : 'false',
                            id: _ctx.$id('item' + child[2]),
                            onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                            onClick: ($event: any) => (_ctx.itemClick(child[2]))
                          }, [
                            _hoisted_9,
                            _renderSlot(_ctx.$slots, "option", {
                              option: child[1],
                              main: false,
                              group: item
                            }, () => [
                              _createTextVNode(_toDisplayString(_ctx.trueOptionLabel(child[1])), 1)
                            ])
                          ], 42, _hoisted_8))
                        : _createCommentVNode("", true),
                      (child === _ctx.selectDivider)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_10))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
            (item[0] === 'option')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  tabindex: "-1",
                  class: _normalizeClass(["dropdown-item", {
              'active': _ctx.selectedIndex === item[2],
          }]),
                  role: "option",
                  "aria-selected": _ctx.selectedIndex === item[2] ? 'true' : 'false',
                  id: _ctx.$id('item' + item[2]),
                  onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                  onClick: ($event: any) => (_ctx.itemClick(item[2]))
                }, [
                  _hoisted_12,
                  _renderSlot(_ctx.$slots, "option", {
                    option: item[1],
                    main: false
                  }, () => [
                    _createTextVNode(_toDisplayString(_ctx.trueOptionLabel(item[1])), 1)
                  ])
                ], 42, _hoisted_11))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 40, _hoisted_4),
    _createElementVNode("input", _hoisted_13, null, 512)
  ], 64))
}